import { LoadingButton } from '@mui/lab';
import { Box,Button, Card, Grid, Stack, Typography } from '@mui/material';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import ConfirmationDialog from 'src/components/ConfirmationDialog';
import { FormProvider, RHFTextField, RHFUploadAvatar } from 'src/components/hook-form';
import LinearProgressBar from 'src/components/progress-bar/progressBar.component';
import HttpServices from 'src/services/httpService';
import { imageModeuleUrl, userModuleURL } from 'src/services/urlService';
import { CommonHelper } from 'src/utils/commonHelper';
import { LocalStorage } from 'src/utils/storage/local-storage';
import { useToaster } from 'src/utils/toaster/toasterContext';
import ValidationTool from 'src/utils/validationHelper';
import TimeZoneSelect from 'src/components/time-zone/time-zone.component';
import { useTranslation } from 'react-i18next';


const BrandInfoComponent = () => {
  const { t: translate } = useTranslation();
  const isOrgUser = CommonHelper.GetBrandInfoFromLocalStorage('is_org_user');
  const isReseller = CommonHelper.GetBrandInfoFromLocalStorage("is_reseller");
  const activeBrandId = CommonHelper.GetCurrentBrandId();
  const isBrandAdminHasPermission = CommonHelper.CheckForPermissionAvailableForUser(CommonHelper.PermissionList.BRAND_ADMIN);
  const maxFileSizeInBytes = 10485760;

  const { showToast } = useToaster();

  const [brandId, setBrandId] = useState(null);
  const [brandName, setBrandName] = useState('');
  const [imageUrl, setBrandImage] = useState('');
  const [brandDescription, setBrandDescription] = useState('');
  const [formSchema, setFormSchema] = useState({});
  const [formValidationErrors, setFormValidationErrors] = useState({});
  const isOrgAdminHasPermission = CommonHelper.CheckForPermissionAvailableForUser(CommonHelper.PermissionList.ORG_ADMIN);
  const [isSaveChangesLoading, setSaveChangesLoader] = useState(false);
  const [isLeaveBrandLoading, setLeaveBrandLoader] = useState(false);
  const [fileUploadprogress, setFileUploadprogress] = useState(0);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [timeZone, setTimeZone] = useState('UTC');
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const [aiKey, setAIKey] = useState('');
  const [hasAiKey, setHasAIKey] = useState(false);
  // const [aiContentKey, setAIContentKey] = useState('');
  // const [hasAiContentKey, setHasAIContentKey] = useState(false);
  const [ideogramImageKey, setIdeogramImageKey] = useState('');
  const [hasIdeogramImageKey, setHasIdeogramImageKey] = useState(false);
  const [geminiImageKey, setGeminiImageKey] = useState('');
  const [hasGeminiImageKey, setHasGeminiImageKey] = useState(false);
  const [chatGptKey, setChatGptKey] = useState('');
  const [hasChatGptKey, setHasChatGptKey] = useState(false);
  const isIntegSocial = CommonHelper.IsIntegSocialDomain();

  useEffect(() => {
    generateFormModelSchema();
    getBrandInfo(activeBrandId);
  }, []);

  const getBrandInfo = () => {
    let getProps = {
      url: userModuleURL.fetchBrandInfo,
      successCallback: brandSuccessCallBack,
      failureCallback,
    };
    HttpServices.Get(getProps);
  };

  const brandSuccessCallBack = (data, message) => {
    setBrandId(data.id);
    setBrandName(data.brand_name);
    setTimeZone(data.timezone);
    setBrandDescription(data.description);
    setBrandImage(data.brand_image);
    setSelectedLanguage(data.language ? data.language : 'english');
    if (data.has_ai_key) {
      setAIKey('**************');
    }
    setHasAIKey(false);
    // if (data.has_ai_content_key) setAIContentKey('**************');
    // setHasAIContentKey(false);
    if (data.has_ideogram_image_key) setIdeogramImageKey('**************');
    setHasIdeogramImageKey(false);
    if (data.has_gemini_image_key) setGeminiImageKey('**************');
    setHasGeminiImageKey(false);
    if (data.has_chatgpt_key) setChatGptKey('**************');
    setHasChatGptKey(false);
  };

  const successCallback = (data, message) => {
    showToast(message, 's');
    setSaveChangesLoader(false);
  };

  const failureCallback = (message) => {
    showToast(message, 'e');
    setSaveChangesLoader(false);
    setLeaveBrandLoader(false);
    setConfirmDeleteOpen(false)
  };

  const handleSubmitForm = () => {
    let userForm = {
      brandName: brandName,
    };
    let { formValidationErrors, isValidForm } = ValidationTool.FormValidation(formSchema, userForm);
    if (isValidForm) {
      setFormValidationErrors({});
      onSubmit();
    } else setFormValidationErrors(formValidationErrors);
  };

  const onSubmit = () => {
    setSaveChangesLoader(true);
    const formattedTimeZone = timeZone.split(':')[0].trim();
    let brandProps = {
      brand_Name: brandName,
      brand_image: imageUrl,
      description: brandDescription,
      timezone: formattedTimeZone,
      ai_key: aiKey,
      has_ai_key: hasAiKey,
      language: selectedLanguage,
      // ai_content_key: aiContentKey,
      // has_ai_content_key: hasAiContentKey,
      ideogram_image_key: ideogramImageKey,
      has_ideogram_image_key: hasIdeogramImageKey,
      gemini_image_key: geminiImageKey,
      has_gemini_image_key: hasGeminiImageKey,
      chatgpt_key: chatGptKey,
      has_chatgpt_key: hasChatGptKey,
    };
    let postProps = {
      url: userModuleURL.updateBrand,
      body: brandProps,
      successCallback: brandDetailsCallback,
      failureCallback,
    };
    HttpServices.Post(postProps);
  };

  const brandDetailsCallback = (data, message) => {
    CommonHelper.SetAllBrandDetials();
    setSaveChangesLoader(false);
    showToast(message, 's');
    window.location.reload();
  };

const confirmDelete = () => {
    setConfirmDeleteOpen(false);
    let brandprops = { brand_id: brandId };
    let postProps = {
      url: userModuleURL.deleteBrand,
      body: brandprops,
      successCallback: updateSuccessCallback,
      failureCallback,
    };
    HttpServices.Post(postProps);
  };
  const updateSuccessCallback = (data, message) => {
      window.location.reload();
  };

  const handleDrop = (acceptedFiles) => {
    const file = acceptedFiles[0];
    handleFileUpload(file);
  };

  const fileUploadSuccessCallback = (data, message) => {
    setBrandImage(data.media_data[0].media_url);
  };

  const handleFileUpload = (file) => {
    let isFileInCorrectFormat = CommonHelper.SupportedImageFormat.some((a) => a.includes(file.type));
    if (isFileInCorrectFormat) {
      if (file.size < maxFileSizeInBytes) {
        setFileUploadprogress(1);
        let formData = new FormData();
        formData.append('fileupload', file);
        axios
          .post(imageModeuleUrl.uploadMedia, formData, {
            headers: HttpServices.GetRequestHeader('form', true),
            onUploadProgress: (data) => {
              let loadedProgress = Math.round((100 * data.loaded) / data.total);
              setFileUploadprogress(loadedProgress > 90 ? 90 : loadedProgress);
            },
          })
          .then((result) => result)
          .then((response) => {
            setFileUploadprogress(100);
            if (response.status === 200 && response.data.http_code === 200)
              fileUploadSuccessCallback(response.data.data, translate('common.file_uploaded_successfully'));
            else showToast(translate('common.something_went_wrong'), 'e');
            setFileUploadprogress(0);
          })
          .catch((error) => {
            setFileUploadprogress(0);
            showToast(error.toString(), 'e');
          });
      } else {
        showToast(`${translate('brand.max_image_size')} 10MB. ${translate('brand.please_select_below')}`, 'e');
      }
    } else {
      showToast(
        `${translate('common.we_only_support')} JPEG, ${translate('common.and')} PNG ${translate(
          'common.file_formats'
        )}. ${translate('common.selected_file_not_in_format')}`,
        'e'
      );
    }
  };

  const handleInputChange = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    switch (name) {
      case 'brandName':
        setBrandName(value);
        break;
      case 'brandDescription':
        setBrandDescription(value);
        break;
      case 'timezone':
        setTimeZone(value);
        break;
      case 'language':
        setSelectedLanguage(value);
        break;
      case 'aiKey':
        setHasAIKey(true);
        if (value?.includes('*')) {
          setAIKey('');
        } else {
          setAIKey(value);
        }
        break;
      // case 'aiContentKey':
      //   setHasAIContentKey(true);
      //   setAIContentKey(value?.includes('*') ? '' : value);
      //   break;
      case 'ideogramImageKey':
        setHasIdeogramImageKey(true);
        setIdeogramImageKey(value?.includes('*') ? '' : value);
        break;
      case 'geminiImageKey':
        setHasGeminiImageKey(true);
        setGeminiImageKey(value?.includes('*') ? '' : value);
        break;
      case 'chatGptKey':
        setHasChatGptKey(true);
        setChatGptKey(value?.includes('*') ? '' : value);
        break;
      default:
        break;
    }
  };

  const leaveCallback = (data, message) => {
    window.location.href = window.location.origin;
  };

  const handleLeave = () => {
    setConfirmOpen(true);
  };
  const handleDelete = () => {
    setConfirmDeleteOpen(true);
  };

  const handleLeaveBrand = () => {
    setLeaveBrandLoader(true);
    let postProps = {
      url: userModuleURL.leaveBrand,
      successCallback: leaveCallback,
      failureCallback,
    };
    HttpServices.Post(postProps);
  };

  const generateFormModelSchema = () => {
    let fields = [ValidationTool.GenerateSchema('brandName', translate('brand.brand_name'), 'TEXT', true)];
    const schema = ValidationTool.GenerateSchemaModel(fields, translate);
    setFormSchema(schema);
  };

  const timezoneCallback = (data, message) => {
    message && showToast(message, 's');
  };

  const handleChangeTimeZone = (event) => {
    let value = event.target.value;
    setTimeZone(value);
    LocalStorage.setItem('timezone', JSON.stringify(value));
    let bodyProps = {
      timezone: value,
    };
    let postProps = {
      url: userModuleURL.changeTimeZone,
      body: bodyProps,
      successCallback: timezoneCallback,
      failureCallback,
    };
    HttpServices.Post(postProps);
  };

  const handleDeleteBrandImage = () => {
    setBrandImage('');
  };

  const defaultValues = {
    brandName: brandName || '',
    imageUrl: imageUrl || '',
    brandDescription: brandDescription || '',
    timeZone: timeZone || '',
  };

  const methods = useForm({
    defaultValues,
  });

  const { handleSubmit } = methods;

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(handleSubmitForm)}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Box display="flex" flexDirection="column" height="100%">
            <Card sx={{ pt: 10, pb: 5, px: 3, textAlign: 'center', flexGrow: 1 }}>
              <Box position="relative" display="inline-block">
                <RHFUploadAvatar
                  name="imageUrl"
                  accept="image/*"
                  onDrop={handleDrop}
                  handleDeleteProfiles={handleDeleteBrandImage}
                  url={imageUrl}
                  helperText={
                    <Typography
                      variant="caption"
                      sx={{
                        mt: 2,
                        mx: 'auto',
                        display: 'block',
                        textAlign: 'center',
                        color: 'text.secondary',
                      }}
                    >
                      {translate('brand.allowed')} *.jpeg, *.jpg, *.png, *.gif
                      <br /> {translate('brand.max_size_of')} 5Mb
                    </Typography>
                  }
                />
              </Box>
              <Stack alignItems="center" justifyContent="center">
                {!isOrgUser && !isReseller && (
                  <LoadingButton variant="contained" loading={isLeaveBrandLoading} onClick={handleLeave}>
                    {translate('profile.profile_details.leave_brand_button')}
                  </LoadingButton>
                )}
                {isOrgUser && !isReseller && isOrgAdminHasPermission && (
                  <Button variant="contained" color="error" onClick={handleDelete}>
                    {translate('common.delete')}
                  </Button>
                )}
                <ConfirmationDialog
                  open={confirmOpen}
                  onClose={() => setConfirmOpen(false)}
                  onConfirm={handleLeaveBrand}
                  title={translate('profile.profile_details.confirm_dialog.title')}
                  message={translate('profile.profile_details.confirm_dialog.message')}
                />
              </Stack>
            </Card>
            {fileUploadprogress > 0 && <LinearProgressBar value={fileUploadprogress} />}
          </Box>
        </Grid>

        <Grid item xs={12} md={8}>
          <Box display="flex" flexDirection="column">
            <Card sx={{ p: 3, flexGrow: 1 }}>
              <Box
                sx={{
                  display: 'grid',
                  rowGap: 3,
                  columnGap: 2,
                  gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)' },
                }}
              >
                <RHFTextField
                  name="brandName"
                  label={translate('brand.brand_name')}
                  value={brandName}
                  onChange={handleInputChange}
                  error={formValidationErrors?.brandName}
                  helperText={formValidationErrors?.brandName}
                />
                {!isIntegSocial && <RHFTextField
                  name="aiKey"
                  label={translate('manage_brand.brand_info.ai_content_key_label')}
                  value={aiKey}
                  onChange={handleInputChange}
                  helperText={
                    <a
                      href="https://www.youtube.com/watch?v=ZEQ102Wq1Lk"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        textDecoration: 'none',
                        marginLeft: '-10px',
                        cursor: 'pointer',
                      }}
                    >
                      {`${translate('manage_brand.brand_info.ai_content_key_help_text')}? (${translate('common.enable')} gpt-4o)`}
                    </a>
                  }
                />}
              </Box>
              {!isIntegSocial && <Box sx={{ mt: 3, p: 2, border: '1px solid #eee', borderRadius: 2 }}>
                <Typography variant="subtitle1" sx={{ mb: 2 }}>
                  {translate('manage_brand.brand_info.additional_keys') || 'Additional Keys'}
                </Typography>
                <Box
                  sx={{
                    display: 'grid',
                    rowGap: 3,
                    columnGap: 2,
                    gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(3, 1fr)' },
                  }}
                >
                  <RHFTextField
                    name="ideogramImageKey"
                    label={translate('manage_brand.brand_info.ideogram_image_key_label') || 'Ideogram Image Key'}
                    value={ideogramImageKey}
                    onChange={handleInputChange}
                  />
                  <RHFTextField
                    name="geminiImageKey"
                    label={translate('manage_brand.brand_info.gemini_image_key_label') || 'Gemini Image Key'}
                    value={geminiImageKey}
                    onChange={handleInputChange}
                  />
                  <RHFTextField
                    name="chatGptKey"
                    label={translate('manage_brand.brand_info.chatgpt_key_label') || 'ChatGPT Key'}
                    value={chatGptKey}
                    onChange={handleInputChange}
                  />
                </Box>
              </Box>}
              <Box
                sx={{
                  display: 'grid',
                  rowGap: 3,
                  columnGap: 2,
                  gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)' },
                  mt: 3,
                }}
              >
                <Stack>
                  <TimeZoneSelect name="timezone" value={timeZone} onChange={handleInputChange} />
                </Stack>
                {/* <LanguageSelect selectedLanguage={selectedLanguage} handleChange={handleInputChange} /> */}
              </Box>
              <Stack spacing={3} alignItems="flex-end" sx={{ mt: 3 }}>
                <RHFTextField
                  name="brandDescription"
                  multiline
                  rows={5}
                  label={translate('manage_brand.brand_info.brand_description')}
                  value={brandDescription}
                  onChange={handleInputChange}
                />
              </Stack>
              {isBrandAdminHasPermission && (
                <Stack alignItems="flex-end">
                  <Stack spacing={3} direction="row" sx={{ mt: 3 }}>
                    <LoadingButton type="submit" variant="contained" loading={isSaveChangesLoading}>
                      {translate('common.save_changes')}
                    </LoadingButton>
                  </Stack>
                </Stack>
              )}
            </Card>
          </Box>
        </Grid>
      </Grid>
        <ConfirmationDialog
              open={confirmDeleteOpen}
              onClose={() => setConfirmDeleteOpen(false)}
              onConfirm={confirmDelete}
              title={translate('common.confirm_deletion')}
              message={`${translate('common.confirm_delete_brand')}?`}
            />
    </FormProvider>
  );
};

export default BrandInfoComponent;
